export const END_POINTS = {
  GET_ALL_COUNTRY_CODE: "country/get-all",

  GET_HOME_PAGE_DATA: "tournament/get-homepage-data",
  // auth user endpoints
  GET_AVATAR_IMAGES: "avtar/get-urls",
  SIGN_UP: "user/auth/signup",
  LOGIN: "user/auth/login",
  GET_USER_DATA: "user/get-user",
  FORGOT_PASSWORD: "user/forgot-password",
  VERIFY_OTP: "user/verify-otp",
  CHANGE_PASSWORD: "user/change-password",
  UPDATE_PASSWORD: "user/reset-password",
  UPDATE_PROFILE: "user/update-profile",
  GET_ALL_USER: "user/get-all",
  GET_USER_BY_ID: "user/get-user-by-id",
  BLOCK_USER: "user/block-user",
  REPORT_USER: "user/report-user",
  CHANGE_EMAIL: "user/change-email",
  DELETE_ACCOUNT: "user/delete-account",
  SEND_VERIFICATION_EMAIL: "user/send-otp",
  LOGOUT: "user/auth/logout",

  // Tournaments end points
  PAST_TOURNAMENTS: "tournament/filtered/Past_Tournament",
  ONGOING_TOURNAMENTS: "tournament/filtered/Ongoing",
  UPCOMING_TOURNAMENTS: "tournament/filtered/Upcoming",
  MY_TOURNAMENT: "tournament/mytournaments",
  GET_TOURNAMENT_BY_ID: "tournament/get",
  FEATURED_TOURNAMENT: "tournament/featured",
  REGISTER_TOURNAMENT: "tournament/enroll",
  GET_GAME_ID_BY_TOURNAMENT: "gameId/get-gameId",
  LEAVE_TOURNAMENT: "tournament/unenrollment",

  // prizepool endpoints
  GET_PRIZEPOOL_DATA: "team/get-players-ranking",

  // invite for tournament
  INVITE_FRIEND_FOR_TOURNAMENT: "tournament/invite-friend",

  // notification
  GET_ALL_NOTIFICATION: "notification/get-all",
  NOTIFICATION_SEEN: "notification/change-status",

  // Group chat endpoints
  GET_USER_BY_TOURNAMENT: "user/tournament-wise-users",
  GET_BRACKET_DATA: "game/get-brackets",

  // Score submission
  SCORE_SUBMISSION: "score/submit-score",
  GET_SCORE: "score/getLastScore",

  // Game ID edit end points
  EDIT_GAME_ID: "game/udpate-gameID",
  GET_GAME_TYPE: "gameType/get-all-gameTypes",

  // comment Endpoints
  ADD_COMMENT: "comment/add-comment",

  // report issue endpoints
  REPORT_ISSUE: "issue/report-issue",

  // Join academy
  JOIN_ACADEMY: "tournament/join-academy",

  CONTACT_US: "contactus/add-contact",

  // Leaderboard endpoints
  LEADERBOARD_DATA: "team/get-leader-board-data",

  // Coins request
  WITHDRAW_REQUEST: "coins/make-request",

  // Game Types
  GET_ALL_GAME_TYPES: "gameType/get-all-oneVsone",
  GET_ALL_DUEL_GAME_TYPES: "gameType/get-all-duel",

  // One To One Game endpoints
  GET_GAME_WISE_USER: "one-vs-one/get-players",
  ONE_TO_ONE_REGISTRATION: "one-vs-one/register",
  INVITE_PLAYER: "one-vs-one/invite-player",
  ACCEPT_INIVITATION: "one-vs-one/accept-invitation",
  DECLINE_INVITATION: "one-vs-one/decline-invitation",
  // CANCEL_INVITATION: "one-vs-one/cancel-invitation",
  CANCEL_GAME: "one-vs-one/cancel-game",
  GET_USER_ONE_TO_ONE_GAME_RATIO: "one-vs-one/win-loss-ratio",
  ONE_TO_ONE_SCORE_SUBMISSION: "one-vs-one/submit-score",
  GET_ONE_TO_ONE_GAME_RULES: "rule/get-rule",
  START_ONE_TO_ONE_GAME: "one-vs-one/start-game",
  CLEAR_INVITATIONS: "one-vs-one/clear-all-invitations",

  // Modified endpoints
  SELECTED_GAMES_ROOMS: "game-preferences/set",
  GET_USERS_SELECTED_GAMES: "game-preferences",
  CREATE_ROOM: "duel/rooms/create",
  UPDATE_ROOM: "duel/rooms/update",
  DELETE_ROOM: "duel/rooms/delete",
  GET_ALL_ROOMS_BY_GAME: "duel/rooms/active",
  JOIN_ROOM: "duel/rooms/join",
  LEAVE_ONE_TO_ONE_GAME_ROOM: "duel/rooms/leave",
  ACCEPT_JOIN_REQUEST: "duel/requests/approve",
  DECLINE_JOIN_REQUEST: "duel/requests/decline",
  START_MATCHMAKING: "duel/rooms/random-play",
  LEAVE_DUEL_ROOM: "duel/rooms/leave",
  DELETE_WAITLIST_REQUEST: "duel/rooms/waitlists/decline",
  APPROVE_WAITLIST_REQUEST: "duel/rooms/waitlists/approve",
  CANCEL_MATCH: "duel/rooms/cancel-match",
  MY_ROOMS: "duel/rooms/my-rooms",
  GET_ROOM_DETAILS: "duel/rooms",
  GET_CURRENT_ACTIVE_MATCH: "duel/rooms/current-active-match",
  GET_IS_IN_ACTIVE_MATCH: "duel/rooms/is-in-active-match",
  GET_WAITLIST_REQUEST: "duel/rooms/waitlists",

  // Market place end-points
  GET_CATEGORIES: "category/get-categories",
  GET_PRODUCTS: "product/get-products",
  GET_PRODUCT_BY_ID: "product/get-product",
  GET_BANNER: "product/get-banners",
  ADD_TO_CART: "cart/add-to-cart",
  GET_ALL_CART_ITEMS: "cart/get-cart-items",
  REMOVE_ITEM_FROM_CART: "cart/remove-from-cart",
  UPDATE_CART_ITEM_QUANTITY: "cart/update-cart-item",
  FETCH_ALL_ORDERS: "order/get-orders",
  PLACE_ORDER: "order/place-order",
  CATEGORY_VISIBILITY: "category/category-visibility",
  // Get IP address
  GET_IP_ADDRESS: "https://ipapi.co/json/",
  // check user daily login (rewards)
  CHECK_USER_LOGIN_REWARDS: "gamification/check-in",
  CLAIM_REWARDS: "gamification/claim-reward",
  GET_PROGRESS: "gamification/get-progresses",
};
